import { useParams, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useTasks } from "../context/TaskContext";
import TaskForm from "../components/TaskForm";

const priorityColor = { High: "bg-red-100 text-red-700", Medium: "bg-yellow-100 text-yellow-700", Low: "bg-green-100 text-green-700" };
const statusColor = { Todo: "bg-gray-100 text-gray-600", "In Progress": "bg-blue-100 text-blue-700", Done: "bg-emerald-100 text-emerald-700" };

export default function TaskDetail() {
  const { id } = useParams();
  const { tasks, updateTask, deleteTask } = useTasks();
  const navigate = useNavigate();
  const [editing, setEditing] = useState(false);

  const task = tasks.find((t) => t.id === Number(id));
  if (!task) return <p className="text-center text-gray-400 py-20">Task not found.</p>;

  if (editing)
    return (
      <div className="max-w-lg mx-auto bg-white rounded-xl shadow p-6">
        <h2 className="font-semibold text-lg mb-4">Edit Task</h2>
        <TaskForm initial={task} onSubmit={(t) => { updateTask({ ...task, ...t }); setEditing(false); }} onCancel={() => setEditing(false)} />
      </div>
    );

  return (
    <div className="max-w-lg mx-auto bg-white rounded-xl shadow p-6 space-y-4">
      <button onClick={() => navigate(-1)} className="text-sm text-blue-600 hover:underline">← Back</button>
      <h2 className="text-xl font-bold text-gray-800">{task.title}</h2>
      <p className="text-gray-600">{task.description || "No description."}</p>
      <div className="flex gap-2 flex-wrap">
        <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${priorityColor[task.priority]}`}>{task.priority}</span>
        <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${statusColor[task.status]}`}>{task.status}</span>
        {task.dueDate && <span className="text-xs text-gray-400">Due: {task.dueDate}</span>}
      </div>
      <div className="flex gap-2 pt-2">
        <button onClick={() => setEditing(true)} className="px-4 py-2 rounded bg-blue-600 text-white hover:bg-blue-700 text-sm">Edit</button>
        <button onClick={() => { deleteTask(task.id); navigate("/"); }} className="px-4 py-2 rounded bg-red-50 text-red-600 hover:bg-red-100 text-sm">Delete</button>
      </div>
    </div>
  );
}
